import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import AutomotivePage from "./AutomotivePage";
import TextilePage from "./TextilePage";

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/industries/automotive" element={<AutomotivePage />} />
        <Route path="/industries/textile" element={<TextilePage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
